import { render, staticRenderFns } from "./ProductCreation.vue?vue&type=template&id=12889292"
import script from "./ProductCreation.vue?vue&type=script&lang=js"
export * from "./ProductCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports